var U = /* @__PURE__ */ ((L) => (L.DOB = "DOB", L.USDC = "USDC", L.SELL_TOKEN = "sellToken", L.U_HODL = "uHODL", L.SELL_TOKEN_HODL = "sellTokenHODL", L.WETH = "WETH", L.U_SNIPER = "uSNIPER", L.SELL_TOKEN_SNIPER = "sellTokenSNIPER", L.U_BULLET = "uBULLET", L.SELL_TOKEN_BULLET = "sellTokenBULLET", L))(U || {});
const r = "uHODL";
var e = /* @__PURE__ */ ((L) => (L[L.SELL = 0] = "SELL", L[L.BUY = 1] = "BUY", L))(e || {}), D = /* @__PURE__ */ ((L) => (L.U_HODL = "1", L.SELL_TOKEN_HODL = "2", L))(D || {});
export {
  U as BASE_TOKEN_SYMBOL,
  r as BAZAAR_DEFAULT_BUY_TOKEN,
  D as HODL_POOL_TYPE,
  e as OPTION_TYPE
};
//# sourceMappingURL=index.mjs.map
